import { render, staticRenderFns } from "./related-transactions.vue?vue&type=template&id=bbcc3278&scoped=true&"
import script from "./related-transactions.vue?vue&type=script&lang=js&"
export * from "./related-transactions.vue?vue&type=script&lang=js&"
import style0 from "./related-transactions.vue?vue&type=style&index=0&id=bbcc3278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcc3278",
  null
  
)

export default component.exports